const MANAGER = 'Manager';
const ADMIN = 'Admin';
const CUSTOMER = 'Customer';
const ESTIMATOR = 'Estimator';
const CREW = 'Crew';
const SALES = 'Sales';

const AppName = {
  MANAGER,
  ADMIN,
  CUSTOMER,
  ESTIMATOR,
  CREW,
  SALES,
};

export default AppName;
